var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrudential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1045.5907 219.63995",
    width: 1045.5907,
    height: 219.63995,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs7"
  }, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#040405;}")), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.39999,
    y: 429.82001,
    width: 1045.6,
    height: 219.67,
    id: "rect4",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    transform: "translate(-152.4093,-429.82001)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2",
    clipPath: "url(#clip-path)",
    id: "g27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_296",
    "data-name": "Trazado 296",
    className: "cls-3",
    d: "m 1198,604.74 v 7.15 h -43.77 v -7.15 a 11.32,11.32 0 0 0 7.74,-2 13.38,13.38 0 0 0 1.7,-8.44 v -92.08 a 19.65,19.65 0 0 0 -1.49,-9.4 9.3,9.3 0 0 0 -8.24,-3 h -3.19 v -6.62 l 37,-2.87 v 114.06 c 0,5.85 1.57,9.16 4.72,9.86 a 23.31,23.31 0 0 0 5.47,0.49",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_297",
    "data-name": "Trazado 297",
    className: "cls-3",
    d: "m 1146.32,604.73 q -7.72,0 -7.72,-10.65 v -42.74 q 0,-30.93 -35,-30.94 a 44.47,44.47 0 0 0 -23.76,6 17.8,17.8 0 0 0 -9.58,15.63 13.09,13.09 0 0 0 4.45,10.54 13.37,13.37 0 0 0 8.93,3.25 13.06,13.06 0 0 0 9.37,-3.54 10.53,10.53 0 0 0 3.79,-7.85 c 0,-7.15 -3.82,-10.74 -11.37,-10.74 a 10.72,10.72 0 0 0 -3.68,0.6 16.49,16.49 0 0 1 4.32,-3.32 23.51,23.51 0 0 1 11.65,-3 q 16.74,0 16.74,15.34 v 14.08 a 121.71,121.71 0 0 0 -35.46,11.07 25.2,25.2 0 0 0 -14.08,22.77 22.87,22.87 0 0 0 5.32,15.06 25.36,25.36 0 0 0 20.59,8.29 27.47,27.47 0 0 0 14.85,-4.45 26.8,26.8 0 0 0 9.91,-10.41 v 4.4 c 0.13,2.6 0.13,5.21 0,7.8 h 32 v -7.15 z m -31.87,-27 a 34.54,34.54 0 0 1 -3.35,16.91 12.77,12.77 0 0 1 -11.28,7.68 8.48,8.48 0 0 1 -7,-3.62 17,17 0 0 1 -2.87,-10.64 20.56,20.56 0 0 1 6.12,-16.54 42.14,42.14 0 0 1 18.36,-6.93 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_298",
    "data-name": "Trazado 298",
    className: "cls-3",
    d: "m 1060.49,604.73 v 7.16 h -44.24 v -7.15 h 2.37 c 3.51,0 5.73,-1.14 6.63,-3.3 a 47.45,47.45 0 0 0 0.83,-11.71 v -46.62 c 0,-6.31 -0.6,-10 -1.91,-11.13 a 8.07,8.07 0 0 0 -5.56,-1.68 h -2.36 v -7.13 h 34 v 66.5 a 31.89,31.89 0 0 0 1.35,12.84 7.59,7.59 0 0 0 6.44,2.22 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_299",
    "data-name": "Trazado 299",
    className: "cls-3",
    d: "m 1052,498.22 a 14.07,14.07 0 0 1 -4.34,10.37 14.35,14.35 0 0 1 -20.31,0.34 l -0.33,-0.34 a 14.12,14.12 0 0 1 -4.26,-10.37 13.85,13.85 0 0 1 4.24,-10.22 14.65,14.65 0 0 1 20.64,0 13.81,13.81 0 0 1 4.34,10.25",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_300",
    "data-name": "Trazado 300",
    className: "cls-3",
    d: "m 1010.34,578 a 63.55,63.55 0 0 1 -3.31,25 22,22 0 0 1 -22,11.48 c -14.82,0 -22.27,-8.4 -22.27,-25.2 v -59.1 h -16 v -7.08 h 2.44 a 26.1,26.1 0 0 0 22.21,-14.8 49,49 0 0 0 8,-25.34 h 7.46 v 40.09 h 17 v 7.15 h -17 v 62.08 c 0,7.33 2.25,11 6.78,11 q 6,0 7.72,-10.41 A 116,116 0 0 0 1002,578 Z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    className: "cls-3",
    d: "m 951.37,604.67 v 7.16 h -34.68 v -65.45 a 21.32,21.32 0 0 0 -1.63,-9.76 9.16,9.16 0 0 0 -8.88,-4.34 11.28,11.28 0 0 0 -9.91,6 35,35 0 0 0 -3.72,17.9 v 33.56 a 34,34 0 0 0 1.07,12.57 10.7,10.7 0 0 0 7.94,2.33 h 1.49 v 7.16 h -45.18 v -7.16 h 2.41 a 6.48,6.48 0 0 0 7.38,-5.44 6.23,6.23 0 0 0 0.08,-1.06 85.61,85.61 0 0 0 0.24,-8.77 v -44.51 a 29.76,29.76 0 0 0 -1.54,-12.66 c -1,-1.52 -3.2,-2.28 -6.47,-2.28 h -2.06 v -7.14 h 31.94 v 11.59 a 23.9,23.9 0 0 1 9.72,-10.07 28.73,28.73 0 0 1 14.81,-3.91 q 26.79,0 26.79,29.11 v 40.56 q 0,6.74 0.11,8.12 c 0.32,4.33 3.08,6.49 8.2,6.49 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    className: "cls-3",
    d: "m 838,597 a 22.4,22.4 0 0 1 -17.67,8.72 q -14.65,0 -18.49,-21 a 106.82,106.82 0 0 1 -1.39,-19.48 h 54.21 a 51.54,51.54 0 0 0 -9,-31.68 34.8,34.8 0 0 0 -29.66,-13.16 38.79,38.79 0 0 0 -29.81,12.94 48.93,48.93 0 0 0 -11.91,34 50.61,50.61 0 0 0 10.48,33.66 38.93,38.93 0 0 0 31.94,13.59 35.51,35.51 0 0 0 27,-11.8 33.65,33.65 0 0 0 10,-22.16 h -9 A 25.42,25.42 0 0 1 838,597 m -37.16,-47.16 q 1.86,-22.62 15,-22.65 14.05,0 14.09,30.6 h -29.45 c 0.08,-3.19 0.22,-5.83 0.38,-7.95",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    "data-name": "Trazado 303",
    className: "cls-3",
    d: "m 771.59,604.79 a 7.89,7.89 0 0 1 -7.23,-2.87 14.49,14.49 0 0 1 -1.36,-7.53 V 480.28 l -37.38,2.87 v 6.66 h 2.44 q 7.07,0 9.13,3.84 a 27.86,27.86 0 0 1 1.47,10.21 223.72,223.72 0 0 0 0.72,25.1 21.29,21.29 0 0 0 -19.48,-8.22 34.25,34.25 0 0 0 -29.07,15.41 52.62,52.62 0 0 0 -9.75,31.31 60.19,60.19 0 0 0 7.26,31.43 31,31 0 0 0 28.75,15.65 26.35,26.35 0 0 0 17.4,-6.17 25.43,25.43 0 0 0 6.31,-7.82 l 0.48,11.29 h 31.94 v -7.05 z m -32.74,-28.93 a 57,57 0 0 1 -1.06,12.3 C 735.57,598 730.86,603 723.71,603 q -15,0 -15.06,-35.54 a 115.47,115.47 0 0 1 1.72,-23.33 q 3.4,-14.53 13.67,-14.54 14.82,0 14.81,28.25 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    className: "cls-3",
    d: "m 677.27,604.68 a 7.67,7.67 0 0 1 -6.56,-2.32 31.56,31.56 0 0 1 -1.33,-12.77 v -66.85 h -36.73 v 7.46 h 2.54 a 10.94,10.94 0 0 1 8.16,2.24 42.18,42.18 0 0 1 1.32,15.37 v 27.08 a 54.64,54.64 0 0 1 -1.35,13.85 c -2.13,8.4 -6.13,12.52 -12.08,12.52 q -10.82,0 -10.8,-13 v -65.49 h -33.66 v 7.45 h 0.76 c 3.84,0 6.26,1 7.29,2.85 a 51.27,51.27 0 0 1 1.06,14.72 v 37.26 A 34.78,34.78 0 0 0 601,606 a 25.37,25.37 0 0 0 21.78,8.52 26,26 0 0 0 16.44,-5.71 25.63,25.63 0 0 0 7.29,-8.51 l 0.44,11.51 h 32.62 v -7.16 z m -30.88,-6.25 z m 1,-0.56 -0.39,0.22 v 0 c 0.22,-0.15 0.42,-0.29 0.62,-0.41 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    className: "cls-3",
    d: "m 581.48,532.37 a 13,13 0 0 1 -3.07,8.42 11.1,11.1 0 0 1 -8.78,4.09 10.67,10.67 0 0 1 -8,-3.1 8,8 0 0 1 -2.57,-6.65 13,13 0 0 1 0.36,-1.86 51.21,51.21 0 0 0 -7.86,21.3 115.71,115.71 0 0 0 -2.39,22 v 17.72 a 15.46,15.46 0 0 0 1.41,8.12 c 1.14,1.52 4.26,2.22 9.22,2.22 h 3 v 7.16 h -48.61 v -7.16 H 516 a 11.54,11.54 0 0 0 7.21,-1.78 c 1.45,-1.14 2.12,-4.07 2.12,-8.52 v -38.59 a 107.06,107.06 0 0 0 -1.06,-22.2 5.93,5.93 0 0 0 -6,-3.59 h -2.54 v -7.14 h 30.45 l 0.62,17.4 q 5,-19.79 21.42,-19.78 a 13.78,13.78 0 0 1 9.58,3.27 11.21,11.21 0 0 1 3.63,8.7",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    className: "cls-3",
    d: "m 347.44,610.42 a 110.73,110.73 0 0 1 -168.78,0 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    className: "cls-3",
    d: "M 372.47,549.6 A 107,107 0 0 1 352,605.33 h -24.66 l 23.35,-36.85 7.05,-24 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    className: "cls-3",
    d: "m 312.56,575.2 -16,30.13 h -15.42 l 28.56,-35.57 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    className: "cls-3",
    d: "m 353.51,543.19 -10.23,24 -9.33,8 -18.52,30.13 h -12.16 l 12.19,-21.51 9.58,-8 13.84,-38.75 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    className: "cls-3",
    d: "m 335.21,535.82 -13.45,25.3 -7.37,1.31 1.95,-14.76 -1.95,-2.89 1.95,-16.66 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    className: "cls-3",
    d: "m 255.83,502.84 c -16,-17 -16.62,-17.95 -16.62,-17.95 l 19.22,1.63 -13.72,-12.83 v -13.13 l 18,3.2 49,28.48 56.67,15.36 a 108.32,108.32 0 0 0 -104.4,-77.81 110.15,110.15 0 0 0 -111.53,106.64 111.34,111.34 0 0 0 21.77,69.2 c 7.05,-16 20.5,-48.64 20.5,-48.64 l 5.76,-3.2 8.33,-23.06 4.81,-2.21 -18.9,58 -13.45,18.91 H 187 l 22.75,-27.25 10.89,-42.27 4.16,5.75 c -1.61,19.55 -1,14.76 -2.25,25.63 l -27.21,38.15 h 6.39 l 26.62,-20.23 1.61,0.65 -9.94,19.56 H 249.5 L 294.67,575.28 308.46,525 341.74,523.39 329,515 Z m -32.65,-22.1 -12.48,31.72 a 49.31,49.31 0 0 0 -8.64,3.81 c 0,0 -18.58,49.73 -27.88,74.64 a 97.77,97.77 0 0 1 -14.08,-54.46 102.69,102.69 0 0 1 103.75,-99.61 100.5,100.5 0 0 1 92.87,60.55 L 307.09,483.62 262.88,459 l -21.74,-3.53 -9.94,21.15 z",
    style: {
      fill: "#040405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    className: "cls-3",
    d: "M 495,491.15 A 63.92,63.92 0 0 0 460.36,483 H 411.8 v 7 a 27.5,27.5 0 0 1 10.74,1.22 c 2.35,1.32 3.54,4.94 3.54,10.87 v 91.57 a 11.24,11.24 0 0 1 -2.95,9.1 15.92,15.92 0 0 1 -9.13,1.84 h -2.2 v 7.16 h 57.77 v -7.16 h -6 a 14.49,14.49 0 0 1 -9.46,-2.22 11.46,11.46 0 0 1 -2.51,-8.72 v -37 h 8.52 a 63.74,63.74 0 0 0 35,-8.52 A 31.27,31.27 0 0 0 510,520 31.94,31.94 0 0 0 495,491.08 m -34.66,57.5 h -8.12 V 490.5 h 8.12 q 23.16,0 23.19,29.68 0,28.44 -23.19,28.44",
    style: {
      fill: "#040405"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrudential);
export default __webpack_public_path__ + "static/media/prudential.30487b62384f475204a5ba592d8638b7.svg";
export { ForwardRef as ReactComponent };